<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div>
  <Pagesubtitle subTitle="Manage how you receive notifications for all spaces." />
  <p class="my-2 text-right">Your email: <span class="font-medium">{{ $store.state.auth.firebaseUser.email }}</span> | <a href="" @click.prevent="$router.push('/dash/settings/myprofile')">Change email ></a></p>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="w-full block overflow-auto pb-4 relative" v-if="notificationsLoading">
        <div class="text-center py-10">
          <p class="mb-2">Loading notifications...</p>
          <div class="w-8 h-8 pt_loading inline-block"></div>
        </div>
      </div>
      <div v-else>
        <h5 class="mb-6" v-if="notifications.length > 1">Feedback notifications</h5>
        <vs-input v-if="notifications.length > 4" v-model="filter" class="my-2 w-full" placeholder="Filter by space name"></vs-input>
        <vx-card class="w-full mb-6" v-for="notf in notifications" v-if="notf.name.indexOf(filter) !== -1">
          <label class="vs-input--label block mb-2"><span :class="{'font-medium': notifications.length > 1, 'text-xl': notifications.length > 1}">{{ notifications.length > 1 ? notf.name : 'FEEDBACK NOTIFICATIONS' }}</span></label>
            <p class="my-2">When would you like to be notified of new feedback for {{ notf.name  }}?</p>
            <div class="my-4">
              <vs-radio :vs-name="'ntfsi' + notf.eID" v-model="notf.settings.period" vs-value="i" class="text-dark font-medium">Immediately</vs-radio>
              <p>An email notification within minutes of getting new feedback.</span></p>
            </div>
            <div class=" my-4">
              <vs-radio :vs-name="'ntfsd' + notf.eID" v-model="notf.settings.period" vs-value="d" class="text-dark font-medium">Daily</vs-radio>
              <p>One daily summarized email for the past day's feedback.</p>
            </div>
            <div class="my-4">
              <vs-radio :vs-name="'ntfsw' + notf.eID" v-model="notf.settings.period" vs-value="w" class="text-dark font-medium">Weekly</vs-radio>
              <p>One weekly summarized email for the week's feedback.</p>
            </div>
            <vs-divider/>
            <div class="my-4">
              <vs-radio :vs-name="'ntfsn' + notf.eID" v-model="notf.settings.period" vs-value="n" class="text-dark font-medium">Never</vs-radio>
              <p>We won't send any email notifications for new feedback.</p>
            </div>
            <vs-divider/>
            <div class="my-4">
              <vs-checkbox v-model="notf.settings.referralLead" class="text-dark font-medium">New referral leads</vs-checkbox>
              <p class="mt-2">An email notification when someone is referred to your business through your referral program.</p>
            </div>
      </vx-card>
      <vx-card class="w-full mb-6 mt-2">
        <label class="vs-input--label block mb-2">Product Notifications and Tips</label>
        <vs-checkbox v-model="receiveUpdates">Receive new product updates and tips on how to get the most out of Feedback Link.</vs-checkbox>
      </vx-card>
      </div>
    </div>
  </div>
  <savebutton submitText="Update" :accept="updateNotifications" :goodToGo="formReady" />
</div>
</template>


<script>
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'
import Savebutton from './components/ptcomponents/Savebutton.vue'

export default {
  data() {
    return {
      notificationsLoading: false,
      notifications: false,
      receiveUpdates: false,
      setupState: false,
      filter: ''
    }
  },
  components: {
    Pagesubtitle,
    Savebutton
  },
  computed: {
    formReady() {
      return !this.notificationSettings && this.notifications && (JSON.stringify({
        notifications: this.notifications,
        receiveUpdates: this.receiveUpdates
      }) !== this.setupState)
    }
  },
  methods: {
    initSetupState() {
      this.setupState = JSON.stringify({
        notifications: this.notifications,
        receiveUpdates: this.receiveUpdates
      })
    },
    updateNotifications() {

      this.$vs.notify({
        title: 'Updating Notifications',
        text: 'Updating notification settings...',
        color: 'primary',
        time: 2000,
        iconPack: 'feather',
        icon: 'icon-alert-circle'
      })

      this.$store.dispatch('dash/UPDATE_NOTIFICATIONS', {
        notificationSettings: this.notifications,
        receiveUpdates: this.receiveUpdates
      }).then((res) => {
        this.initSetupState()
          this.$vs.notify({
            title: 'Update Notifications',
            text: 'Notification settings updated.',
            color: 'success',
            time: 20000,
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
      }).catch(() => {
        let initialState = JSON.parse(this.setupState)
        this.notifications = initialState.notifications
        this.receiveUpdates = initialState.receiveUpdates
        this.$vs.notify({
          title: 'Update Notifications',
          text: 'Oops! We had an issue trying to update your notification settings. Please try again or get support at support@feedback.link with the code \'una\'',
          color: 'warning',
          time: 40000,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })

    },
    loadNotifications() {
      this.notifications = false
      this.notificationsLoading = true
      this.$store.dispatch('dash/LIST_NOTIFICATIONS').then((notfs) => {
        //referralLead didn't exist before June 2026 — docs that predate the backfill come
        //back without it. Default missing to ON unless the user opted out of notification
        //email entirely (period 'n') — same rule as the backfill script. $set because a
        //dynamically added key isn't reactive, and normalize BEFORE initSetupState so it
        //doesn't mark the form dirty.
        notfs.settings.forEach((notf) => {
          this.$set(notf.settings, 'referralLead', typeof notf.settings.referralLead !== 'undefined' ? notf.settings.referralLead === true : notf.settings.period !== 'n')
        })
        this.notifications = notfs.settings
        this.receiveUpdates = notfs.receiveUpdates
        this.initSetupState()
        this.notificationsLoading = false
      }).catch(() => {
        this.notificationsLoading = false
        this.notifications = false
        this.$vs.notify({
          title: 'Notifications',
          text: 'Oops! We had an issue trying to get your notifications settings. Please try again or get support at support@feedback.link',
          color: 'warning',
          time: 40000,
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      })
    }
  },
  created() {
    this.loadNotifications()
  }
}
</script>

<style lang="scss">
.icontop {
    position: relative;
    top: 0.1rem;
}
</style>
